






























import { Component, Vue } from 'vue-property-decorator'
import Navigator from '../components/blocks/navigator.vue'
// import Header from '../components/blocks/header.vue'
// import FloatUtil from '../components/blocks/float-util.vue'
import Footer from '../components/blocks/footer.vue'
import PopNews from '../components/blocks/pop-news.vue'
@Component({
  components: {
    Navigator,
    PopNews,
    // Header,
    // FloatUtil,
    Footer
  }
})
export default class extends Vue {
  // 是不是忘记密码 忘记密码不要页面脚 src\portal\views\forgot-password\forgot-password.vue
  get isForgotPassword() {
    const name = this.$route.name
    console.log(name)
    if (name === 'ForgotPassword') {
      return true
    }
    return false
  }
}
